import { render, staticRenderFns } from "./UserAudio.vue?vue&type=template&id=ca1a11ba&scoped=true&"
import script from "./UserAudio.vue?vue&type=script&lang=js&"
export * from "./UserAudio.vue?vue&type=script&lang=js&"
import style0 from "./UserAudio.vue?vue&type=style&index=0&id=ca1a11ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1a11ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca1a11ba')) {
      api.createRecord('ca1a11ba', component.options)
    } else {
      api.reload('ca1a11ba', component.options)
    }
    module.hot.accept("./UserAudio.vue?vue&type=template&id=ca1a11ba&scoped=true&", function () {
      api.rerender('ca1a11ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/User/UserAudio.vue"
export default component.exports